/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudIcon20Solid = forwardRef('NetCloudIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.25 3a5.502 5.502 0 0 0-5.36 4.265A5.002 5.002 0 0 0 5.5 17H14a5.5 5.5 0 0 0 .151-10.998A5.5 5.5 0 0 0 9.25 3Z" })));
});
